import { useSelector } from 'react-redux';

import { filterStudyEventDefinitionByStudyArm } from '../utils';

export function useStudyEventDefinitionsFilteredByStudyArm({ studyEventDefinitions = [] } = {}) {
  const { data: protocol } = useSelector((state) => state.protocolReducer.protocol);
  const { data: studyEventDefinitionFilteredByStudyArm } = useSelector(
    (state) => state.protocolReducer.studyEventDefinitionFilteredByStudyArm,
  );

  const filteredStudyEventDefinitions = filterStudyEventDefinitionByStudyArm({
    currentFilteredStudyArm: studyEventDefinitionFilteredByStudyArm,
    studyArms: protocol?.studyArms,
    studyEventDefinitions: studyEventDefinitions,
  });

  return { filteredStudyEventDefinitions, studyEventDefinitionFilteredByStudyArm };
}

export default useStudyEventDefinitionsFilteredByStudyArm;
